
import { Component, Vue } from "vue-property-decorator";
import config from "./config";
// import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
// import { parseTime } from "@/utils";
@Component({
  name: "Form3",
  // filters: {
  //   parseValue(value: any, prop: string) {
  //     if (value instanceof Date) {
  //       return parseTime(value);
  //     }
  //     return value;
  //   },
  // },
  components: {
    // YtoTable,
  }
})
export default class extends Vue {
  // @Watch("formmodel3", { deep: true })
  // onChildChanged(val: string) {
  //   this.$emit("get-form2-value", val);
  // }
  mounted() {
    try {
      this.SetDefaultDateRange();
      obj_ScanForWeighbridgeList.regist_datahistorycallback(
        this.datahistorycallback
      );
    } catch (error) {
      console.log("地磅称重3Vue出现异常:" + error);
    }

    // this.list = this.states.map((item) => {
    //   return { value: `${item}`, label: `${item}` };
    // });
  }
  public cleardisable() {
    // this.pickerMinDate = null;
  }
  public currentRow = null;
  public handleCurrentChange(val) {
    this.currentRow = val;
  }
  public datahistorycallback(datahistory) {
    this.showPrintedList = datahistory;
  }
  public timeOptionRange: String = "";

  public pickerOptions = {
    onPick: time => {
      if (time.minDate && !time.maxDate) {
        this.timeOptionRange = time.minDate;
      }
      if (time.maxDate) {
        this.timeOptionRange = null;
      }
    },
    disabledDate: time => {
      let timeOptionRange: any = this.timeOptionRange;
      let secondNum = 6 * 60 * 60 * 24 * 1000;
      if (timeOptionRange) {
        return (
          time.getTime() > timeOptionRange.getTime() + secondNum ||
          time.getTime() < timeOptionRange.getTime() - secondNum
        );
      }
    }
  };
  public loading = false;
  public list = [];
  public option = [];
  public states = ["Alabama", "Alaska", "Arizona"];
  public remoteMethod(query) {
    if (query !== "") {
      this.loading = true;
      var result = obj_ScanForWeighbridgeList.queryCP(query);
      var resultObj = JSON.parse(result);
      this.list = resultObj.CPList.map(item => {
        return { value: `${item}`, label: `${item}` };
      });
      setTimeout(() => {
        this.loading = false;
        this.option = this.list.filter(item => {
          return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      }, 200);
    } else {
      this.option = [];
    }
  }

  public alert(title, message) {
    if (title == null) {
      title = "错误信息";
    }
    this.$alert(message, title, {
      confirmButtonText: "确定",
      callback: null
    });
  }
  private QueryWeightRecordFunc() {
    if (this.formmodel3.input_DateRange == null) {
      this.alert(null, "请先选择日期");
      return;
    }
    obj_ScanForWeighbridgeList.queryWeightRecord(this.formmodel3);
  }
  private PrintRecordFunc() {
    if (this.currentRow == null) {
      this.alert(null, "请先选择要打印的行！");
      return;
    }
    obj_ScanForWeighbridgeList.printRecord(this.currentRow);
  }

  private SetDefaultDateRange() {
    this.formmodel3.input_DateRange = [];

    var _lastday = new Date();
    _lastday.setDate(_lastday.getDate() - 1);
    var _today = new Date();
    _today.setDate(_today.getDate());

    this.formmodel3.input_DateRange.push(_lastday);
    this.formmodel3.input_DateRange.push(_today);
  }

  public carlabel = "";
  private config = config;

  private formmodel3: inputDataModel_WeighbridgeList = {
    input_CarLabel: "",
    input_LicensePlateNumber: "",
    input_DateRange: [],
    checked_NeedVolumn: false,
    checked_NeedWeight: false
  };
  public showPrintedList = [];

  public options = [
    {
      value: "",
      label: ""
    }
  ];
}
